import { union, difference } from 'lodash';

const initialState = {
  fetched: false,
  data: null,
  uiState: { selectedAccountTypes: [] },
};

export default function(state = initialState, action) {
  switch (action.type) {
    case 'ACCOUNTS_MODULE_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, { fetched: true, data: action.payload });
      } else {
        return Object.assign({}, state, { fetched: true, data: null });
      }
    case 'SAVINGS_ACCOUNT_TYPE_SELECTED':
      return Object.assign({}, state, {
        uiState: Object.assign({}, state.uiState, {
          selectedAccountTypes: union(state.uiState.selectedAccountTypes, [action.payload]),
        }),
      });
    case 'SAVINGS_ACCOUNT_TYPE_UNSELECTED':
      return Object.assign({}, state, {
        uiState: Object.assign({}, state.uiState, {
          selectedAccountTypes: difference(state.uiState.selectedAccountTypes, [action.payload]),
        }),
      });
    default:
      return state;
  }
}
